import { Information } from "@carbon/icons-react";
import { IconButton, Popover, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface SerialNumbersInfoProps {
  serialNumbers: string[];
}

const SerialNumbersInfo = (props: SerialNumbersInfoProps) => {
  const { serialNumbers } = props;
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const hasSerialNumbers = serialNumbers.length > 0;

  return (
    <>
      <Tooltip
        title={t("noSerialNumbers")}
        disableHoverListener={hasSerialNumbers}
      >
        <span>
          <IconButton
            disabled={!hasSerialNumbers}
            onClick={(event: React.MouseEvent<HTMLButtonElement>) =>
              setAnchorEl(event.currentTarget)
            }
          >
            <Information size={20} />
          </IconButton>
        </span>
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <div className="serial-popover-content">
          <div className="serial-popover-content-header">
            {t("serialNumbers")}
          </div>
          {hasSerialNumbers ? (
            <div className="serial-popover-content-list">
              {serialNumbers.map((serialNumber) => (
                <div key={serialNumber} className="serial-popover-content-item">
                  {serialNumber}
                </div>
              ))}
            </div>
          ) : (
            <Typography variant="body2">-</Typography>
          )}
        </div>
      </Popover>
    </>
  );
};

export default SerialNumbersInfo;
